export default "/bundles/assets/photo4_532f6e2080bb844669ca6e12031d4d8b.png";